<template>
    <b-dropdown
        id="btn-target-actions"
        :no-caret="true"
        :dropleft="true"
        :text="$t('form.button.edit')"
        variant="link"
        size="sm"
        :disabled="!isAllowedToEdit"
    >
        <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-lg"></i>
        </template>
        <b-dropdown-item id="btn-target-edit" @click="$emit('edit', { targetId, targetLevel })">
            {{ $t('form.button.edit') }}
        </b-dropdown-item>
        <b-dropdown-item id="btn-target-delete" @click="$emit('delete', { targetId, targetLevel })">
            {{ $t('form.button.delete') }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: 'EditButton',
    props: ['targetId', 'targetLevel', 'isAllowedToEdit'],
}
</script>
